import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BasketActionAddCoupon from '@/b2c/basket/ui/actions/BasketActionAddCoupon.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'GiftCardPaymentTileModel',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BasketActionAddCoupon, {
    "checkout-mode": true,
    class: "max-w-400 mx-auto mt-x8 mb-x4"
  }))
}
}

})